const CONTEXT_MISMATCH_MESSAGE = (
  '검사 기준을 확인하지 못했어요. 서버 업데이트가 끝난 뒤 다시 검사해주세요.'
);


const sameContext = (actual, expected) => (
  Number(actual?.academic_year) === Number(expected?.academic_year)
  && Number(actual?.record_grade) === Number(expected?.record_grade)
);


export const assertInspectorContextResponse = (
  response,
  {
    academicYear,
    contextMode = 'uniform',
    recordGrade,
    students = [],
  },
) => {
  if (!response || response.cancelled || response.success === false) {
    return response;
  }

  if (contextMode !== 'mixed') {
    if (!sameContext(response, {
      academic_year: academicYear,
      record_grade: recordGrade,
    })) {
      throw new Error(CONTEXT_MISMATCH_MESSAGE);
    }
    return response;
  }

  if (response.context_mode !== 'mixed') {
    throw new Error(CONTEXT_MISMATCH_MESSAGE);
  }
  const actualResults = response.results || [];
  if (actualResults.length !== students.length) {
    throw new Error(CONTEXT_MISMATCH_MESSAGE);
  }

  const actualBySegment = new Map(
    actualResults
      .filter(result => result.segment_id)
      .map(result => [result.segment_id, result]),
  );
  const matches = students.every((expected, index) => {
    const actual = (
      expected.segment_id
        ? actualBySegment.get(expected.segment_id)
        : actualResults[index]
    );
    return sameContext(actual, expected);
  });
  if (!matches) {
    throw new Error(CONTEXT_MISMATCH_MESSAGE);
  }
  return response;
};


export { CONTEXT_MISMATCH_MESSAGE };
